import { THEME_NAMES } from 'ui/styles/config/theme.constants';
import { getAppTheme } from 'ui/styles/theme';

export const defaultTheme = getAppTheme(THEME_NAMES.DEFAULT);
